export const feeRulesMockData = {
  noticeText: '以下规则仅用于说明服务费计费方式，实际费用以购物车结算时的计算结果为准。',
  sections: [
    {
      feeType: 'FINANCE',
      feeTypeName: '金融服务费',
      displayMode: 'DETAIL',
      rules: [
        {
          ruleId: 3001,
          ruleName: '金融服务费',
          formulaText: '订单金额（除金融服务费外的所有费用） × 0.0X%'
        }
      ]
    },
    {
      feeType: 'PURCHASE',
      feeTypeName: '代采服务费',
      displayMode: 'DETAIL',
      rules: [
        {
          ruleId: 2001,
          ruleName: '代采服务费',
          tiers: [
            { min: 0, max: 100, fee: 1.5, unit: '元/件' },
            { min: 100, max: 300, fee: 2, unit: '元/件' },
            { min: 300, max: null, fee: 2.5, unit: '元/件' }
          ]
        }
      ]
    },
    {
      feeType: 'TRANSPORT',
      feeTypeName: '运输服务费',
      displayMode: 'DETAIL',
      rules: [
        {
          ruleId: 1001,
          ruleName: '全部商品运输服务费',
          goodsScope: 'ALL',
          detailText: '基础运输费 0.10 元/斤，平台运输费 0.20 元/斤'
        },
        {
          ruleId: 1002,
          ruleName: '运输服务费',
          goodsScope: 'PART',
          settlementTip: '具体收费标准以购物车的金额为准'
        }
      ]
    }
  ]
}
